import React from 'react';

const LibresSection = ({ orientacion, puntos, renderFormularioMateria, renderListaMaterias }) => (
  <div>
    <div style={{
      backgroundColor: 'var(--bg-hover)',
      color: 'var(--text-primary)',
      padding: '10px 15px',
      borderRadius: '4px',
      marginBottom: '15px',
      border: '1px solid var(--border-color)'
    }}>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
        <span>Puntos acumulados:</span>
        <span style={{ fontWeight: 'bold' }}>{puntos.libresGeneralesCPO || 0}/8</span>
      </div>
    </div>
    <p style={{ marginBottom: '15px', color: 'var(--text-primary)' }}>
      Debés elegir materias de al menos dos departamentos diferentes entre:
    </p>
    <ul style={{
      listStyle: 'none',
      padding: '0',
      margin: '0 0 15px 0'
    }}>
      {orientacion.departamentosLibres?.map((depto, index) => (
        <li key={index} style={{
          padding: '8px 12px',
          backgroundColor: 'var(--bg-primary)',
          color: 'var(--text-primary)',
          marginBottom: '5px',
          borderRadius: '4px',
          border: '1px solid var(--border-color)'
        }}>• {depto}</li>
      ))}
    </ul>
    {renderFormularioMateria('libresGeneralesCPO', 8, orientacion.departamentosLibres)}
    {renderListaMaterias('libresGeneralesCPO', 'Materias Libres Cursadas')}
    <p style={{
      fontSize: '0.9em',
      color: 'var(--text-secondary)',
      fontStyle: 'italic'
    }}>
      Nota: Las materias de Tributario cuentan para Económico Empresarial y las de Notarial para Privado.
    </p>
  </div>
);

export default LibresSection;
